// Data structure constants for consistent analytics

export const AI_SOURCES = [
  'ChatGPT-4',
  'Claude-3.5-Sonnet',
  'Claude-3.5-Haiku', 
  'Gemini-Ultra',
  'Gemini-Pro',
  'Grok',
  'Human-Team-Member'
];

export const PROJECT_TYPES = [
  'Marketing',
  'Development',
  'Sales',
  'Operations',
  'Strategy',
  'Research'
];

export const PROJECT_STATUS = [
  'Active',
  'Paused',
  'Completed',
  'Archived'
];

export const PLATFORMS = [
  'LinkedIn',
  'Reddit', 
  'Twitter/X',
  'Facebook',
  'Instagram',
  'TikTok',
  'YouTube',
  'Email',
  'Blog',
  'Website',
  'Podcast',
  'Other'
];

export const CONTENT_TYPES = [
  'Short-form Post',
  'Long-form Post',
  'Comment',
  'Video',
  'Image',
  'Infographic',
  'Email',
  'Article',
  'Poll',
  'Story',
  'Live Stream',
  'Other'
];

export const TONE_TAGS = [
  'Professional',
  'Humorous',
  'Conversational',
  'Educational',
  'Controversial',
  'Inspirational',
  'Technical',
  'Emotional'
];

export const HOOK_TAGS = [
  'Question',
  'Stat/Number',
  'Controversial Statement',
  'Personal Story',
  'How-to',
  'List',
  'Behind-the-scenes',
  'Trend/News'
];

export const ENTITY_TYPES = [
  'Person',
  'Company',
  'Influencer',
  'Media Contact',
  'Customer',
  'Prospect',
  'Partner',
  'Competitor'
];

export const ACTION_STATUS = [
  'Pending',
  'In Progress',
  'Completed',
  'Failed',
  'Cancelled'
];

export const DEFAULT_METRIC_FIELDS = [
  'views',
  'likes',
  'shares',
  'comments',
  'clicks',
  'conversions',
  'reach',
  'impressions'
];

// Standardized tag categories for analytics
export const TAG_CATEGORIES = {
  tone: TONE_TAGS,
  hook: HOOK_TAGS,
  platform: PLATFORMS,
  content_type: CONTENT_TYPES
};

// Helper function to validate tags
export function validateTags(tags) {
  const validTags = [];
  const errors = [];
  
  tags.forEach(tag => {
    const [category, value] = tag.split(':');
    if (TAG_CATEGORIES[category] && TAG_CATEGORIES[category].includes(value)) {
      validTags.push(tag);
    } else {
      errors.push(`Invalid tag: ${tag}`);
    }
  });
  
  return { validTags, errors };
}